export class ConfigurationSearchModel {
    name: string | undefined;
    configKey: string | undefined;
    groupId: string | undefined;
    configurationTypeCode: string | undefined;
  }